import { render, staticRenderFns } from "./PvPvcList.vue?vue&type=template&id=f85d4a68&"
import script from "./PvPvcList.vue?vue&type=script&lang=js&"
export * from "./PvPvcList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports